




















import { Component, Vue } from 'vue-property-decorator';
import JobServiceFormEdit from '@/components/jobServiceForm/JobServiceFormEdit.vue';
import { JobServiceForm } from '@/models/jobServiceForm/jobServiceForm';
import { Job } from '@/models/jobDetail/job';
import * as JobsAPI from '@/api/jobsApi';
import Nullable from '@/types/nullable';
import { RiskMatrixOptions } from '../models/jobServiceForm/riskMatrixOptions';

@Component({
  components: {
    JobServiceFormEdit
  }
})
export default class ViewJobServiceForm extends Vue {
  private loading: boolean = false;
  private errorMessage: string = null;
  private jobServiceForm: Nullable<JobServiceForm> = null;
  private riskMatrixOptions: Nullable<RiskMatrixOptions> = null;
  private job: Job = null;

  created() {
    this.init();
  }

  handleDataChanged(){
    this.init();
  }

  async init(){
    this.loading = true;

    try {
      this.jobServiceForm = await JobsAPI.getServiceForm(this.$route.params.jobID);
      this.job = await JobsAPI.getJob(this.$route.params.jobID);
      this.riskMatrixOptions = await JobsAPI.getRiskMatrixOptions();

      if (this.$route.params.shouldSendEmail && this.jobServiceForm.clientJobCompleteSignOff != null) {
        console.log('Sending Email');
        await JobsAPI.emailServiceForm(this.job.id, this.job.client.location.contactEmail);
      }
    } catch (err){
      this.errorMessage = err;
    }

    this.loading = false;
  }
}

